export default __webpack_public_path__ + "static/media/2.386d06a9.jpg";